var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewportFive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "viewportFive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.929,
    height: 111,
    viewBox: "0 0 135.929 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    transform: "translate(60.888) rotate(90)",
    fill: "none",
    stroke: "#f6c543",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111,
    height: 60.888,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 103,
    height: 52.888,
    rx: 14,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    transform: "translate(135.929) rotate(90)",
    fill: "none",
    stroke: "#e388ad",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49.647,
    height: 60.929,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 41.647,
    height: 52.929,
    rx: 14,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    transform: "translate(135.929 62.5) rotate(90)",
    fill: "none",
    stroke: "#427a98",
    strokeWidth: 8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.5,
    height: 60.929,
    rx: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40.5,
    height: 52.929,
    rx: 14,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewportFive);
export default __webpack_public_path__ + "static/media/viewportFive.8792afccaad3342bfa79b8795ab7b3d7.svg";
export { ForwardRef as ReactComponent };